import { t } from '../../../locales';
import AddCompanyButton from './pages/shipping-companies/components/add-company-btn.vue';
import LinkMarketplaceTitle from './pages/link-marketplace/components/header-title.vue';
import MarketplacesActionsBtn from './pages/marketplaces/components/header-actions.vue';
import { featureFlag, isFeatureFlagEnabled } from '../../entities/feature-flag';

const integrationsModuleRoutes = {
	path: 'integrations',
	component: () => import('./module-layout.vue'),
	children: [
		{
			path: 'shipping-companies',
			component: () => import('./pages/shipping-companies/index.vue'),
			meta: {
				title: t('shipping-companies'),
				headerExtraComponent: AddCompanyButton,
				featureFlag: featureFlag.E_COMMERCE,
			},
		},
		{
            path: 'test/connect-instagram',
			component: () => import('./pages/link-marketplace/components/instagram/connect-instagram.vue'),
			meta: {
				title: 'Test: Connect Instagram',
			},
		},
		{
			path: 'link-marketplace/:id',
			component: () => import('./pages/link-marketplace/index.vue'),
			props: true,
			meta: {
				// TODO: translate
				title: 'Link Marketplace',
				headerTitleComponent: LinkMarketplaceTitle,
			},
		},
		{
			path: 'marketplaces',
			component: () => import('./pages/marketplaces/index.vue'),
			meta: {
				title: () => isFeatureFlagEnabled(featureFlag.E_COMMERCE)
					? t('integrations.linked-marketplaces')
					: t('integrations.linked-communication-channels'),
				headerExtraComponent: MarketplacesActionsBtn,
			},
		},
	],
};

export { integrationsModuleRoutes };
